import Vue from 'vue';
import Vuex from 'vuex';
import { AppModule } from './AppModule';
Vue.use(Vuex);
const store = {
    state: {
        version: '1.0.0'
    },
    modules: {
        AppModule
    }
};
export default new Vuex.Store(store);
